import { Component, Input, EventEmitter, Output, Inject } from "@angular/core";
import { FormGroup, FormArray } from "@angular/forms";
import { PollinationType } from "../../../../shared/services/pollination-type.service";
import { ConjunctionEnum } from "../../../../shared/models/conjunction.enum";
import { CE_REQUEST_OPTIONS, ResolvedRequestOptionsService } from "../../../services/resolved-request-options";

@Component({
  selector: "app-pollination-preference-group",
  templateUrl: "./pollination-preference-group.component.html",
  styleUrls: ["./pollination-preference-group.component.css"]
})
export class PollinationPreferenceGroupComponent {
  @Input() preferenceGroup: FormGroup;
  @Input() index: number;
  @Input() preferenceCount: number;
  @Input() focused: boolean;
  @Input() canDelete: boolean = true;
  @Input() groupLabel: string = '';
  @Input() shouldHideConjunction: boolean = false;

  @Output() onDelete: EventEmitter<number> = new EventEmitter();
  @Output() onFocus: EventEmitter<number> = new EventEmitter();
  @Output() onDeleteLastItem: EventEmitter<number> = new EventEmitter();

  public pollinationTypes: PollinationType[];

  public get conjunctionEnum() {
    return ConjunctionEnum;
  }

  public get items(): FormArray {
    return <FormArray>this.preferenceGroup.get("items");
  }

  public get hasItems(): boolean {
    return this.items && this.items.length > 0;
  }

  constructor(@Inject(CE_REQUEST_OPTIONS) private routeData: ResolvedRequestOptionsService) {
    this.pollinationTypes = this.routeData.requestOptions.pollinationTypes;
  }

  public delete(): void {
    if (this.canDelete) {
      this.onDelete.emit(this.index);
    }
  }

  public deleteLastItem(): void {
    if (this.hasItems) {
      this.onDeleteLastItem.emit(this.index);
    }
  }

  public focus(): void {
    this.onFocus.emit(this.index);
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-preference-group/pollination-preference-group.component.ts